<template>
  <div class="good_detail" v-loading="spuLoading" element-loading-text="拼命加载中">
    <div v-if="spuInfo && spuInfo.sparePartsId">
      <div class="detail_content home_page">
        <!-- 商品spu或sku信息显示 -->
        <div class="good_spku_info">
          <div class="good_info_imgs flex-shrink">
            <img v-if="spuInfo && spuInfo.imageList && spuInfo.imageList[mainGraphIndex]"
                 :src="spuInfo && spuInfo.imageList && spuInfo.imageList[mainGraphIndex].url"
                 alt=""
                 width="386px"
                 height="386px">
            <img v-else src="@/assets/img/bitmap.png"
                 alt=""
                 width="386px"
                 height="386px">
            <!-- 图片轮播图 -->
            <div class="img-carousel" v-show="spuInfo && spuInfo.imageList && spuInfo.imageList.length">
              <el-carousel indicator-position="none"
                           height="60px"
                           v-if="spuInfo && spuInfo.imageList">
                <el-carousel-item v-for="(i, ind) in Math.ceil(spuInfo.imageList.length/5)"
                                  :key="ind">
                  <div class="imgs-row">
                    <img :src="item.url"
                         alt="商品主图"
                         width="60px"
                         height="60px"
                         v-for="(item, index) in spuInfo.imageList.slice(ind*5, ind*5 + 5)"
                         :key="index"
                         @click="changeShowImg(ind*5 + index)"
                         class="img_left">
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="good_info_content flex-grow">
            <div class="good_spku_info" style="margin-top: 0;">
              <div class="flex-grow">
                <!-- sku 标题-->
                <div class="good_title line-break">
                  {{spuInfo.sparePartsName}}
                </div>
                <!-- 价格 -->
                <div class="good-flex good-original-price">
                  <label class="lable flex-shrink">价格</label>
                  <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
                  <div class="flex-grow original-price">
                    <good-price :fixedNum="4" :price="spuInfo.price"></good-price>
                  </div>
                </div>
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">规格</label>
              <div class="flex-grow good-models">
                {{spuInfo.specification || ''}}
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">型号</label>
              <div class="flex-grow good-models">
                {{spuInfo.model || ''}}
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">数量</label>
              <div class="flex-grow">
                {{spuInfo.supplyNum || ''}}
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">备件编码</label>
              <div class="flex-grow good-models">
                {{spuInfo.supplyCode}}
              </div>
            </div>
            <!-- 活动相关 -->
            <div class="bottom">
              <!-- 标品 -->
              <div>
                <!-- 无活动/拼团 -->
                <div class="good-opt">
                  <el-button class="add-cart"
                             @click="consult()"
                             :loading="loading">
                    咨询
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 商品详情相关信息 -->
        <div class="good_spku_info">
          <el-tabs type="border-card"
                   style="width: 100%">
            <el-tab-pane>
              <span slot="label">商品详情</span>
              <div v-html="spuInfo.remark"
                   class="line-break good_spu_detail"></div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">商品参数</span>
              <div v-for="optionItem in (spuInfo && spuInfo.categoryList) || []"
                   :key="optionItem.attributeItemId"
                   class="groupParams">
                <div class="model-params-name attList">
                  <div class="att-name">{{optionItem.name}}</div>
                  <div class="att-value">{{optionItem.attributeValueList | formatAtt}}</div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="good_spku_info">
          <div style="width:100%;height:46px;background: #f5f5f5; border: 1px solid #dedede;font-size:18px;color:#333;line-height:46px;padding-left:20px">
            宁东工业超市商城价格说明
          </div>
        </div>
        <div class="good_spku_info"
             style="margin-top:0">
          <div style="width:100%;height:201px; border: 1px solid #dedede;font-size:14px;color:#333;padding:20px;border-top:none;">
            <div style="color:#666;line-height:46px"><span style="font-weight:bold">宁东工业超市面价：</span>宁东工业超市面价为宁东工业超市平台在售商品的销售面价，您可以与宁东工业超市平台销售人员咨询最终的交易价格。</div>
            <div style="color:#666"><span style="font-weight:bold">划线价：</span>商品展示的划横线价格为参考价，并非原价，该价格可能是由品牌供应商提供的正品零售价（如供应商指导价、建议零售价等）或该商品在宁东工业超市平台上曾经展示过的销售价，或者该商品的市场价；由于地区、时间的差异性和市场行情波动等可能会与您购物时展示的不一致，该价格仅供您参考。</div>
            <div style="color:#666;line-height:46px"><span style="font-weight:bold">折扣：</span>如无特殊说明，折扣指平台在原价或划线价等某一价格基础上计算出的优惠比例或优惠金额，同一商品不同时享受多个促销活动的折扣；如有疑问，您可在购买前进行咨询。</div>
            <div style="color:#666;"><span style="font-weight:bold">异常问题：</span>商品促销信息以促销专题页中的促销规则为准；商品的具体售价以订单结算页价格为准；如您发现活动商品售价或促销信息有异常，建议购买前进行咨询。</div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_page"
         v-else>
      <div class="no_show_message">
        <img src="@/assets/img/good/noGood.png"
             alt="努力加载中">
        <!-- <div>努力加载中</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import GoodPrice from '@/components/good-price'
export default {
  data () {
    return {
      loading: false,
      spuLoading: false,
      spuInfo: null,
      correlativeSpuInfoList: [], // 搭配型号,
      attributeGroupList: [], // 参数项
      spuDetailInfo: '', // 商品详情
      mainGraphIndex: 0 // 主图索引
    }
  },
  components: {
    GoodPrice
  },
  computed: {
    spuId () {
      return this.$route.query.spuId
    }
  },
  watch: {
    spuId: {
      immediate: true,
      handler: 'getGoodInfo'
    }
  },
  filters: {
    formatAtt (att) {
      return att.map(item => {
        return item.name
      }).join('、')
    }
  },
  methods: {
    // 获取商品详情信息
    getGoodInfo () {
      if (!this.$route.query.sparePartsId) {
        return false
      }
      this.spuInfo = null
      this.correlativeSpuInfoList = []
      this.attributeGroupList = []
      this.skuInfoList = []
      this.spuDetailInfo = ''
      this.spuLoading = true
      this.$http.get(`/front/order/lclb/sparePartsShare/shareInfo/${this.$route.query.sparePartsId}`)
        .then(({ data: res }) => {
          // { data: res }
          console.log(res, 'resgetGoodInfo')
          // res = res.data
          this.spuInfo = res.data
          console.log(this.spuInfo, 'this.spuInfo')
          // this.correlativeSpuInfoList = res.correlativeSpuInfoList
          // this.attributeGroupList = res.attribute ? res.attribute.attributeGroupList || [] : []
          // this.skuInfoList = res.skuInfoList || []
          // this.spuDetailInfo = res.spuDetailInfoForWeb || ''
          // this.getSkuCollect()
        }).finally(() => {
          this.spuLoading = false
        })
    },
    // 更改主图的索引
    changeShowImg (index) {
      this.mainGraphIndex = index
    },
    // 判断当前sku商品是否被收藏
    getSkuCollect () {
      // this.collection = false
      // if (!this.currentSkuInfo.skuId) {
      //   return false
      // }
      // // 未登录
      // if (!getAccessToken()) {
      //   return false
      // }
      // this.loading = true
      // this.$request.post(`/front/commodity-user/app/collected/${this.currentSkuInfo.skuId}`)
      //   .then((res) => {
      //     this.collection = res
      //   })
      //   .catch(() => { })
      //   .finally(() => {
      //     this.loading = false
      //   })
    },
    // 领用/备用
    consult () {
      this.$confirm(this.spuInfo.mobile, '请致电供应商', {
        confirmButtonText: '知道了',
        type: 'warning',
        center: true,
        showCancelButton: false
      }).then(() => {
      }).catch(() => {
      })
    },
    // 查看附件
    viewAttachment (url) {
      if (url) {
        window.open(url)
      }
    },
    // 去咨询
    goconSultHandle () {
      this.$router.push({
        name: 'goodBrandCategoryList'
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.good_detail {
  background: #fff;
  padding-bottom: 30px;
  .activity-but {
    color: #fff;
    background-color: #cb2a22;
  }
  /deep/ .promotion-tab {
    .is-top .is-active {
      color: #fff;
      background-color: #cb2a22;
    }
  }
  .good-flex {
    margin-top: 20px;
    line-height: 20px;
    // letter-spacing: 8px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #555555;
    .lable {
      width: 100px;
      margin-right: 20px;
      padding-left: 20px;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .good_category {
    background: #f2f2f2;
    .good_category_content {
      display: flex;
      justify-content: space-between;
      color: #262727;
      line-height: 48px;
      font-size: 16px;
      font-size: 400;
      .cusService {
        cursor: pointer;
        .img_cusService {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .detail_content {
    padding-top: 20px;
    .good_spku_info {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      // .good_brand{
      //   width: 200px;
      // }
      .good_info_imgs {
        width: 386px;
        .img-carousel {
          margin-top: 32px;
          // height: 60px;
          .imgs-row {
            width: 100%;
            height: 60px;
            padding-left: 20px;
            padding-right: 20px;
            .img_left {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
        .good_sku_opt {
          margin-top: 21px;
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: #555555;
        }
      }
      .good_info_content {
        margin-left: 50px;
        position: relative;
        padding-bottom: 100px;
        .good_title {
          width: 650px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
          margin-bottom: 22px;
          letter-spacing: 2px;
        }
        .good_dec {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 400;
          color: #d92a2a;
          line-height: 22px;
        }
        .group-buying {
          justify-content: space-between;
          padding-left: 13px;
          padding-right: 13px;
          font-size: 18px;
          color: #ffffff;
          line-height: 36px;
          background: linear-gradient(130deg, #ff6793 10%, #ff0c0c 100%);
        }
        .good-original-price {
          margin-top: 0;
          height: 70px;
          background: #f5f5f5;
          .original-price {
            font-size: 14px;
            font-weight: bold;
            color: #e64c3a;
            // letter-spacing: 4px;
            /deep/ .price {
              color: #f63721;
              display: inline-block;
              .price-int {
                font-size: 26px;
                font-weight: 100;
              }
              .price-point {
                font-size: 14px;
              }
            }
            .cross-price {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-decoration: line-through;
              text-align: left;
              color: #666666;
              line-height: 18px;
            }
            .activity-not-start {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              // color: #666666;
              line-height: 18px;
            }
          }
        }
        .good-models {
          font-size: 16px;
          .good-model {
            display: inline-block;
            margin-right: 10px;
            border: 1px solid #dedede;
            padding: 5px 15px;
            color: #333333;
            font-weight: 400;
            font-size: 14px;
            cursor: pointer;
          }
          .good-model-choosed {
            border-color: #2e88ff;
          }
        }
        .bottom {
          position: absolute;
          bottom: 0;
          .good-opt {
            margin-left: 20px;
            color: #fff;
            .buy-imm {
              min-width: 150px;
              border: none;
              background: linear-gradient(132deg, #f97300 8%, #d9271e);
              color: #fff;
            }
            .buy-inquiry {
              min-width: 150px;
              border: none;
              background: #1d65a8;
              color: #fff;
              &:hover {
                background: #134574;
              }
            }
            // 禁用
            .but_ban {
              background: #aaa;
              cursor: not-allowed;
            }
            .add-cart {
              min-width: 150px;
              border: none;
              background: linear-gradient(233deg, #f47205 -22%, #f5b014 94%);
              color: #fff;
              font-size: 18px;
            }
          }
          .good-services {
            display: flex;
            .service {
              margin-right: 10px;
              font-size: 10px;
              .icon-color {
                color: #2e88ff;
              }
            }
          }
        }
      }
      .good_spu_detail {
        // overflow: hidden;
        max-width: 100%;
        img {
          max-width: 100%;
        }
      }
      .groupParams {
        border: 1px solid #eee;
        .model-params-name {
          padding: 12px 20px;
          font-size: 12px;
          line-height: 16px;
          color: #262727;
          font-weight: 500;
        }
        .attList {
          border-top: 1px solid #eee;
          display: flex;
          align-items: center;
          .att-name {
            padding: 10px;
            width: 30%;
            color: #999999;
            line-height: 16px;
            font-weight: 400;
            font-size: 12px;
            text-align: center;
            flex-shrink: 1;
            border-right: 1px solid #eee;
          }
          .att-value {
            padding-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
          }
        }
      }
      .attachment {
        color: #2e88ff;
        cursor: pointer;
      }
    }
    .match-model {
      margin-top: 40px;
      .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
        background: #f5f7fa;
        border: none;
        cursor: default;
      }
    }
    // 搭配型号
    .collocation {
      padding: 20px;
      display: flex;
      .collocation-good {
        width: 180px;
        text-align: center;
        img {
          border: none;
          border: 1px #eee dashed;
        }
        .collocation-good-name {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: #333333;
          line-height: 24px;
        }
      }
      .space {
        margin-left: 60px;
      }
    }
  }
  .promotion {
    margin-top: 10px;
    height: 36px;
    padding-left: 20px;
    line-height: 36px;
    background-image: linear-gradient(-30deg, #ff847e 0%, #e02a21 100%);
    display: -webkit-box;
    display: -ms-flexbox;
    justify-content: space-between;
    color: #fff;
    .promotion-title {
      .promotion-clock-img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
      .promotion-count {
        padding: 3px 20px;
        margin-left: 20px;
        background: #cb2a22;
        border-radius: 10px;
      }
    }
    .promotion-time {
      display: flex;
      .promotion-content-arrow {
        width: 0;
        height: 0;
        border-top: 18px solid transparent;
        border-right: 36px solid #fadad8;
        border-bottom: 18px solid transparent;
      }
      .promotion-content {
        padding-right: 20px;
        text-align: right;
        color: #e02a21;
        background-color: #fadad8;
        // .no-bg{
        //   margin: 5px;
        // }
        /deep/.time-bg {
          text-align: center;
          background: #e02a21;
          color: #fff;
          padding: 5px;
          margin: 5px;
        }
      }
    }
  }
  .home_page {
    height: 100%;
  }
}
</style>
